import { render } from "./TheLocaleSelector.vue?vue&type=template&id=2534b833&scoped=true&ts=true"
import script from "./TheLocaleSelector.vue?vue&type=script&lang=ts"
export * from "./TheLocaleSelector.vue?vue&type=script&lang=ts"

import "./TheLocaleSelector.vue?vue&type=style&index=0&id=2534b833&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2534b833"]])

export default __exports__